const AlertAckRedHeader = () => {
  return (
    <svg width="100%" height="150" viewBox="0 0 390 150" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <mask id="mask0_10498_6376" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="390" height="150">
        <path d="M390 0V150C233.489 104.234 148.123 104.865 0 150V0H390Z" fill="url(#paint0_linear_10498_6376)" />
      </mask>
      <g mask="url(#mask0_10498_6376)">
        <rect width="390" height="319" fill="url(#paint1_linear_10498_6376)" />
        <g opacity="0.5">
          <path d="M390 -10V140C253.489 54.2336 128.123 54.8652 0 140V-10H390Z" fill="url(#paint2_linear_10498_6376)" />
          <path fillRule="evenodd" clipRule="evenodd" d="M390 -10H0V140C128.123 54.8652 253.489 54.2336 390 140V-10Z" fill="url(#paint3_linear_10498_6376)" />
        </g>
        <g opacity="0.5">
          <path d="M390 -51V79C253.489 13.2336 128.123 13.8652 0 79V-51H390Z" fill="url(#paint4_linear_10498_6376)" />
          <path fillRule="evenodd" clipRule="evenodd" d="M390 -51H0V79C128.123 13.8652 253.489 13.2336 390 79V-51Z" fill="url(#paint5_linear_10498_6376)" />
        </g>
      </g>
      <defs>
        <linearGradient id="paint0_linear_10498_6376" x1="195" y1="41.5095" x2="216.91" y2="150.521" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EC4D5B" />
          <stop offset="1" stopColor="#ECA1B0" />
        </linearGradient>
        <linearGradient id="paint1_linear_10498_6376" x1="195" y1="88.2768" x2="282.169" y2="292.214" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EC4D5B" />
          <stop offset="1" stopColor="#ECA1B0" />
        </linearGradient>
        <linearGradient id="paint2_linear_10498_6376" x1="195" y1="31.5095" x2="216.91" y2="140.521" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EC4D5B" />
          <stop offset="1" stopColor="#ECA1B0" />
        </linearGradient>
        <linearGradient id="paint3_linear_10498_6376" x1="195" y1="31.5095" x2="216.91" y2="140.521" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EC4D5B" />
          <stop offset="1" stopColor="#ECA1B0" />
        </linearGradient>
        <linearGradient id="paint4_linear_10498_6376" x1="195" y1="-15.0251" x2="211.617" y2="80.3732" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EC4D5B" />
          <stop offset="1" stopColor="#ECA1B0" />
        </linearGradient>
        <linearGradient id="paint5_linear_10498_6376" x1="195" y1="-15.0251" x2="211.617" y2="80.3732" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EC4D5B" />
          <stop offset="1" stopColor="#ECA1B0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default AlertAckRedHeader
